export default __webpack_public_path__ + "static/media/PiyumiSandunika.8a6de1be.jpg";